import { createTrackingPageProvider } from "@edreamsodigeo/frontend-core";
const TRACKING_CATEGORY = "sso_sign_in_trips";
const PAGE_NAME = "mytripslogin";
const MytripsLoginTrackingPageProvider = createTrackingPageProvider({
  category: TRACKING_CATEGORY,
  pageMapper: () => PAGE_NAME,
  page: PAGE_NAME
});
export default MytripsLoginTrackingPageProvider;